<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { NoteLoggerViewModel } from "@Alternatives/Alternatives/Components/NoteLogger";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class NoteLogger extends Vue
    {
        get vm() { return this.$props.viewModel as NoteLoggerViewModel; }
        get opened() : boolean { return this.vm?.opened; }
        
        note: string | null = null;

        create()
        {
            this.$emit('create-note', this.note)
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Log a note</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <textarea v-model.trim="note" class="form-control" rows="5" placeholder="Enter text here..." />
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button @click="create" :disabled="!note" type="button" class="btn btn-primary">Create</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>      


<style scoped>
</style>